import { createFeature, createReducer, on } from '@ngrx/store';

import {
  loadEnvironmentalImpactDeliveriesCurrentYearSuccess,
  loadEnvironmentalImpactDeliveriesLastYearSuccess,
  loadEnvironmentalImpactWithBenchmarkSuccess,
} from './environmental-impact.actions';
import { EnvironmentalImpactState } from '../environmental-impact.models';
import { cropYearChanged } from '../../../../store/actions';

export const initialEnvironmentalImpactState: EnvironmentalImpactState = {
  environmentalImpactsWithBenchmarks: [],
  environmentalImpactDeliveries: [],
};

export const environmentalImpactFeature = createFeature({
  name: 'environmentalImpact',
  reducer: createReducer(initialEnvironmentalImpactState,
    on(cropYearChanged, () => initialEnvironmentalImpactState),

    on(loadEnvironmentalImpactWithBenchmarkSuccess, (state, { payload: { report } }): EnvironmentalImpactState => ({
      ...state,
      environmentalImpactsWithBenchmarks: [
        ...state.environmentalImpactsWithBenchmarks,
        report,
      ],
    })),

    on(loadEnvironmentalImpactDeliveriesCurrentYearSuccess, (state, { payload: { deliveries } }): EnvironmentalImpactState => ({
      ...state,
      environmentalImpactDeliveries: [...state.environmentalImpactDeliveries, deliveries],
    })),

    on(loadEnvironmentalImpactDeliveriesLastYearSuccess, (state, { payload: { deliveries } }): EnvironmentalImpactState => ({
      ...state,
      environmentalImpactDeliveries: [...state.environmentalImpactDeliveries, deliveries],
    })),
  ),
});
